import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { LoadingContainer, NoData, SectionWrapper } from './ChartList.styles';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { useDiversedSpendContext } from 'contexts/SupplierDiversity/DiversedSpendProvider';
import Header from 'SupplierDiversity/components/Header/Header';

const chartTitle = 'Total Client Vs Total Diversity Spend by Category';

const DiversedSpend = () => {
	const { isLoading, data, options } = useDiversedSpendContext();
	return (
		<SectionWrapper>
			<Header chartTitle={chartTitle} />
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact highcharts={Highcharts} options={options} />
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default DiversedSpend;
